module.exports = __webpack_public_path__ + "static/media/mockupX.86f0286e.webp";